import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { defaultTheme } from '@shorelight/super-form/utils/ThemeUtils';
import { shorelightColorPalette } from '@shorelight/super-form/utils/ThemeUtils/defaultColorPalette';

export const customThemeStyles = createMuiTheme({
  ...defaultTheme,
  typography: {
    fontFamily: 'Rubik',
    fontWeight: 300
  },
  overrides: {
    ...defaultTheme.overrides,
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: shorelightColorPalette.white
        }
      }
    }
  }
});
